import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Labelled } from "@rentiohq/web-shared/dist/components";
import { FieldProps } from "react-native-jsonschema-form-test";
import { PropertyPhotoGallery } from "./PropertyPhotoGallery";

/**
 * The photo gallery as a form field, so it can stand among the other fields
 * instead of after all of them.
 *
 * It holds no form value: every photo is stored the moment it is added, and
 * saving the form neither writes nor clears anything here. The field exists for
 * its position only, which is why it sits in this app beside the gallery rather
 * than in the shared field set.
 */
interface IPropertyPhotosUiSchema {
  propertyId?: number;
  onSaved?: () => void;
}

export const PropertyPhotosField = (props: FieldProps) => {
  const { uiSchema } = props;
  const { propertyId, onSaved } = uiSchema as IPropertyPhotosUiSchema;

  if (!propertyId) {
    return null;
  }

  return (
    <Labelled
      label={getLocalizedText("property.extra.media.item.photos")}
      optional={true}
    >
      <PropertyPhotoGallery
        propertyId={propertyId}
        onSaved={onSaved || (() => undefined)}
      />
    </Labelled>
  );
};
